module.exports = __webpack_public_path__ + "img/2-2.504ebc73.png";